import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { StorageService } from './service/utility/storage/storage.service';

/**
 * Servizio per controllare il routing
 */
@Injectable()
export class TranslateGuard implements CanActivate {
  /**
   * Costruttore
   * @param router Per il redirect
   * @param storageService Per leggere dati utente
   */
  constructor(private router: Router, private storageService: StorageService) {}

  /**
   * Decide se una rotta può essere attivata
   */
  canActivate(query: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (query.queryParams.cID && this.storageService.getStoredObject('currentUser')) {
      return true;
    }
    if (query.queryParams.cID) {
      this.router.navigate(['/extra/login'], {
        queryParams: { ...query.queryParams, returnUrl: state.url.split('?')[0] },
      });
      return false;
    }
    this.router.navigate(['/']);
    return false;
  }
}
